<template>
  <div class="px-8" :class="[readonly && 'opacity-70 pointer-events-none']">
    <slot name="chosenOffer"></slot>

    <div
      v-if="!hideTitle"
      class="flex items-center justify-between pb-4 mb-6 border-b border-gray-200"
    >
      <div class="opacity-75 text-md">Strumenti nel carrello - {{ order_items.length }}</div>

      <div
        class="px-2 py-1 font-medium text-red-500 rounded cursor-pointer pressable bg-red-50"
        @click="() => showConfirm()"
        v-if="canEdit"
      >
        Svuota
      </div>
    </div>

    <div
      class="p-2 mb-3 bg-white border rounded "
      v-for="order_item in order_items"
      :key="order_item.id"
    >
      <div class="flex items-center justify-between">
        <div class="text-sm opacity-75">{{ order_item.item_name_copy }}</div>
        <div
          class="flex items-center px-2 py-1 font-medium text-red-500 rounded cursor-pointer pressable bg-red-50"
          @click="() => showConfirm(order_item)"
          v-if="canEdit"
        >
          <a-icon type="close" />
        </div>
      </div>
      <div class="font-bold capitalize">{{ formatItemLabel(order_item) }}</div>

      <div class="flex items-center justify-between mt-8" v-if="order_item.value">
        <div class="text-sm opacity-75">Valore dichiarato</div>

        <euro-value
          :value="order_item.value"
          class="font-bold"
          smallerDecimals
          symbolBefore
          hideDecimalsIfZero
        />
      </div>
    </div>

    <div
      v-if="canAdd && canEdit"
      @click="addOpened = true"
      class="flex items-center justify-between px-4 py-4 border border-b border-gray-200 border-dashed rounded-md cursor-pointer "
    >
      <span class="font-bold opacity-75">Aggiungi strumento</span>
      <span
        class="flex items-center justify-center w-8 h-8 text-xl font-bold rounded-full r text-i4m-orange"
      >
        +
      </span>
    </div>

    <a-drawer
      title="Aggiungi strumento all'ordine"
      placement="right"
      :closable="true"
      :width="mobile ? '100%' : 600"
      @close="addOpened = false"
      :visible="addOpened"
      :maskClosable="false"
    >
      <add-item-widget
        :onAddedInstrument="onAddedInstrument"
        :onInstrumentFormCompleted="onInstrumentFormCompleted"
        :stopAfterStep="stopAfterStep"
        @added="onAdded"
        @cancel="onCancel"
        ref="addWidget"
      ></add-item-widget>
    </a-drawer>
  </div>
</template>

<script>
import api from '@/api.js';

export default {
  name: 'new-order-sidebar',
  props: {
    readonly: Boolean,
    order_items: {
      type: Array
    },
    canAdd: { type: Boolean, default: false },
    canEdit: { type: Boolean, default: true },
    hideTitle: { type: Boolean },
    stopAfterStep: { type: Number },
    onAddedInstrument: { type: Function },
    onInstrumentFormCompleted: { type: Function }
  },

  computed: {
    mobile() {
      return this.$mq.resize && this.$mq.below('768px');
    }
  },

  data() {
    return {
      addOpened: false
    };
  },

  methods: {
    truncate(text, length = 30) {
      if (text.length > length) {
        return text.substring(0, length) + '...';
      } else {
        return text;
      }
    },

    formatItemLabel(order_item) {
      let str = [];
      if (order_item.luthier) str.push(order_item.luthier);
      if (order_item.model) str.push(order_item.model);

      return this.truncate(str.join(' '));
    },

    onAdded() {
      this.addOpened = false;
      this.$refs.addWidget.reset();
      this.$emit('added');
    },

    onCancel() {
      this.addOpened = false;
      this.$refs.addWidget.reset();
    },

    showConfirm(order_item) {
      const isResettingAll = !order_item;
      const isLastItem = !isResettingAll && this.order_items.length === 1;

      let title = 'Sei sicuro di voler rimuovere questo strumento dal carrello?';
      let content =
        'Rimuovendo le offerte attuali non saranno più valide e ne cercheremo delle altre basate sul tuo carrello aggiornato.';

      if (isLastItem) {
        title = "Vuoi annullare l'ordine?";
        content =
          "E' l'ultimo strumento rimasto nel carrello, rimuovendolo verrai riportato alla pagina inziale dove potrai iniziare un nuovo ordine.";
      }

      if (isResettingAll) {
        title = "Vuoi annullare l'ordine?";
        content = 'Verrai riportato alla pagina inziale dove potrai iniziare un nuovo ordine.';
      }

      this.$confirm({
        title,
        content,
        onOk: async () => {
          try {
            if (isResettingAll) {
              await api.resetOrder();
              this.$router.push('/');

              this.$notification.success({
                message: 'Carrello svuotato!',
                duration: 4
              });

              return this.$store.commit('resetOrder');
            }

            const { data: order } = await api.removeOrderItem(order_item.id);
            this.$store.commit('setOrder', order);

            if (isLastItem) {
              this.$router.push({ name: 'home' });
              this.$notification.success({
                message: 'Carrello svuotato!',
                duration: 4
              });
            }
          } catch (err) {
            console.log(err);
            this.$notification.error({
              message: "Non è stato possbile effettuare l'operazione. Riprova.",
              duration: 4
            });
          }

          return true;
        },
        onCancel() {},
        okText: 'Procedi',
        cancelText: 'Annulla'
      });
    }
  }
};
</script>

<style lang="scss"></style>
